module.exports = __webpack_public_path__ + "static/media/C.25425f71.svg";